const Menu=[{
    id : 1,
    image:"image/clashofclans.jpg",
    name:"Clash of clan",
    category:"Games",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
},
{
    id : 2,
    image:"image/freefire.jpg",
    name:"FREE FIRE",
    category:"Games",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 3,
    image:"image/asur-cast.jpg",
    name:"Asur",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 4,
    image:"image/pubg.jpg",
    name:"Pubg",
    category:"Games",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 5,
    image:"image/lucifer.jpg",
    name:"Lucifer",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 6,
    image:"image/dark.jpg",
    name:"Dark",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 7,
    image:"image/bhaubali.jpg",
    name:"BHAUBALI",
    category:"Bollywood",
    description:"lorem espum lorem espum  lorem espum  lorem espum  ",
   
},
{
    id : 7,
    image:"image/bhaubali2.jpg",
    name:"BHAUBALI",
    category:"Bollywood",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 8,
    image:"image/Black-Punjabi-2019-20191127024538-500x500.jpg",
    name:"black",
    category:"MusicAlbum",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 9,
    image:"image/callofduty.jpg",
    name:"Call of duty",
    category:"Games",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 10,
    image:"image/chota.jpg",
    name:"chota bheem",
    category:"Cartoon",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 11,
    image:"image/clash.jpg",
    name:"Clash",
    category:"MusicAlbum",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 12,
    image:"image/deewar.jpg",
    name:"Deewar",
    category:"Bollywood",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 13,
    image:"image/delhicrime.jpg",
    name:"Delhi crime",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 14,
    image:"image/doremon.jpg",
    name:"Doremon",
    category:"Cartoon",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 15,
    image:"image/FAUG.jpg",
    name:"faug",
    category:"Games",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 16,
    image:"image/goat.jpg",
    name:"g.o.a.t",
    category:"MusicAlbum",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 17,
    image:"image/kabir.jpg",
    name:"kabir",
    category:"Bollywood",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 18,
    image:"image/lagan.jpg",
    name:"lagan",
    category:"Bollywood",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 19,
    image:"image/madeinindia.jpg",
    name:"made in india",
    category:"MusicAlbum",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 20,
    image:"image/Money-Heist-Pakaoo-Review-5.jpg",
    name:"money heist",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 21,
    image:"image/mother.jpg",
    name:"Mother India",
    category:"Bollywood",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 22,
    image:"image/outfit.jpg",
    name:"outfit",
    category:"MusicAlbum",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 23,
    image:"image/paatallok.jpg",
    name:"paatal lok",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 24,
    image:"image/patola.jpg",
    name:"patola",
    category:"MusicAlbum",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 25,
    image:"image/Ray-Web-Series-Poster-Photo.jpg",
    name:"ray",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 26,
    image:"image/redeyes.jpg",
    name:"REd eyes",
    category:"MusicAlbum",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 27,
    image:"image/sabrina.jpg",
    name:"sabrina",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 28,
    image:"image/sacredgames.jpg",
    name:"sacred games",
    category:"WebSeries",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 29,
    image:"image/shinchan.jpg",
    name:"shinchan",
    category:"Cartoon",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 30,
    image:"image/tanu.jpg",
    name:"tanu weds manu",
    category:"Bollywood",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 31,
    image:"image/Tom_and_Jerry_Special_Shorts.jpg",
    name:"tom and jerry",
    category:"Cartoon",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},

{
    id : 32,
    image:"image/vicecity.jpg",
    name:"vice city",
    category:"Games",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 33,
    image:"image/bhajan.jpg",
    name:"bam bhole",
    category:"Bhajan",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 34,
    image:"image/bhajan2.jpg",
    name:"AA mere prabhu",
    category:"Bhajan",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
{
    id : 35,
    image:"image/bhajan1.jpg",
    name:"kumbh Bhajan",
    category:"Bhajan",
    description:"lorem espum lorem espum  lorem espum  lorem espum  "
   
},
];
export default Menu ;